import api from './api';
import { Clergy, PaginatedResponse } from '../types';

interface ClergyFilters {
  search?: string;
  templeId?: string;
  rank?: string;
  isActive?: boolean;
  page?: number;
  limit?: number;
}

export const clergyService = {
  async getList(filters: ClergyFilters = {}): Promise<PaginatedResponse<Clergy>> {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.templeId) params.append('templeId', filters.templeId);
    if (filters.rank) params.append('rank', filters.rank);
    if (filters.isActive !== undefined) params.append('isActive', filters.isActive.toString());
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get<PaginatedResponse<Clergy>>('/clergy', { params });
    return response.data;
  },

  async getById(id: number): Promise<Clergy> {
    const response = await api.get<Clergy>(`/clergy/${id}`);
    return response.data;
  },

  async getBySlug(slug: string): Promise<Clergy> {
    const response = await api.get<Clergy>(`/clergy/slug/${slug}`);
    return response.data;
  },

  async create(data: Omit<Clergy, 'id' | 'createdAt' | 'updatedAt'>): Promise<Clergy> {
    const response = await api.post<Clergy>('/clergy', data);
    return response.data;
  },

  async update(id: number, data: Partial<Clergy>): Promise<Clergy> {
    const response = await api.put<Clergy>(`/clergy/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/clergy/${id}`);
  },

  async toggleActive(id: number): Promise<Clergy> {
    const response = await api.post<Clergy>(`/clergy/${id}/toggle-active`);
    return response.data;
  },
};
